import "@web-components/search";
import { Schema } from "effect";

const DataSchema = Schema.parseJson(
  Schema.Struct({
    sectionId: Schema.String,
  }),
);

const sections = Array.from(document.querySelectorAll(".main-search"));

sections.forEach((section) => {
  const scriptData = section.querySelector('script[type="application/json"]');
  if (!scriptData || !scriptData.textContent) return;
  const { sectionId } = Schema.decodeSync(DataSchema)(scriptData.textContent);
  const searchInput = section.querySelector<HTMLInputElement>(
    `#searchInput-${sectionId}`,
  );
  if (!searchInput) return;
  searchInput.focus({
    //@ts-ignore
    focusVisible: true,
  });
  searchInput.setSelectionRange(-1, -1);
});
